class ProductStyles extends HTMLElement {
    constructor() {
        super();
        this.listEl = this.querySelector('.ProductStyle-swatch-list')
        
        if(!this.listEl) return;

        this.parent_style = this.listEl.dataset.parentStyle
        this.product_type = this.listEl.dataset.productType
        this.currentId = this.listEl.dataset.currentId

        if(this.parent_style && this.product_type) this.loadStyles()
    }
    async loadStyles() {
        const reqUrl = this.request_url()

        const response = await this.getList(reqUrl)

        try {
            if(!response.ok) {
                throw new Error(response.statusText)
                return
            }

            const resultString = await response.text()

            if(!resultString) return

            this.render(resultString)
        } catch (error) {
            console.error(error)
        }
    }
    request_url() {
        return `/search?q=${encodeURI(this.product_type)}&view=${encodeURI('parent-style')}&filter.v.m.custom.parent_style=${encodeURI(this.parent_style)}`
    }
    getList(url) {
        if(!url) return;

        return fetch(url)
    }
    render(result) {
        if(!result) return;

        const html = new DOMParser().parseFromString(result, 'text/html')
        const styleList = html.querySelector('.ProductStyle-result')
        const activeItem = styleList.querySelector(`.ProductStyle-swatch-item[data-variant-id="${this.currentId}"]`)

        if(activeItem) activeItem.classList.add('active')

        console.log(styleList)

        if(styleList) this.listEl.innerHTML = styleList.innerHTML
    }
}

customElements.define('product-style-list', ProductStyles)
